import type { AccountThreadRichView } from '@shared/types/thread-work';

export interface ThreadTopicFocusResult {
  threadState: AccountThreadRichView;
  focused: boolean;
}

/**
 * Projects one exact Topic as the visible Thread focus without mutating the
 * backend ranking. Closed topics remain addressable for audit/deep links;
 * active sibling topics stay visible underneath.
 */
export const focusThreadTopic = (
  threadState: AccountThreadRichView,
  topicId: string | null
): ThreadTopicFocusResult => {
  const normalizedTopicId = topicId?.trim() ?? '';
  const topic = normalizedTopicId
    ? threadState.topics.find((candidate) => candidate.id === normalizedTopicId)
    : null;
  if (!topic) return { threadState, focused: false };

  return {
    focused: true,
    threadState: {
      ...threadState,
      decisionHealth: topic.decision?.health ?? threadState.decisionHealth,
      decisionHealthReasonCode:
        topic.decision?.healthReasonCode ?? threadState.decisionHealthReasonCode,
      currentTopic: topic,
      otherTopics: threadState.topics.filter(
        (candidate) => candidate.id !== topic.id && candidate.visibleState !== 'closed'
      ),
    },
  };
};
